const SpotifyUserService = {

  fetchPlaylists() {
    return new Promise((resolve, reject) => {
      spotifyUser.get('me/playlists')
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },

  fetchPlaylist(playlistId) {
    return new Promise((resolve, reject) => {
      spotifyUser.get(`playlists/${playlistId}`)
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },

  fetchTracks(playlistId) {
    return new Promise((resolve, reject) => {
      spotifyUser.get(`playlists/${playlistId}/tracks`)
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },

  fetchMe() {
    return new Promise((resolve, reject) => {
      spotifyUser.get('me')
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },

  createPlaylist(userId, name) {
    const newPlaylist = {
      name,
      public: false,
    };

    return new Promise((resolve, reject) => {
      window.spotifyUser.post(`users/${userId}/playlists`, newPlaylist)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  updatePlaylist(userId, playlistId, params) {
    return new Promise((resolve, reject) => {
      spotifyUser.put(`users/${userId}/playlists/${playlistId}`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  addPlaylistTrack(playlistId, uris) {
    return new Promise((resolve, reject) => {
      spotifyUser.post(`playlists/${playlistId}/tracks`, { uris })
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },

  removePlaylistTrack(playlistId, uris) {
    return new Promise((resolve, reject) => {
      spotifyUser.delete(`playlists/${playlistId}/tracks`, { data: { uris } })
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },

  unfollowPlaylist(playlistId) {
    return new Promise((resolve, reject) => {
      spotifyUser.delete(`playlists/${playlistId}/followers`)
        .then(() => {
        })
        .catch(error => reject(error));
    });
  },

  request(url) {
    return new Promise((resolve, reject) => {
      spotifyUser.get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default SpotifyUserService;
